module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Densbueren-654b89edb30b6a02096d0033c0fc3178.svg";